import notificacionGlobal from '@infotrack/presentacion-componentes/notificacionGlobal';
import { IPaginador } from '@infotrack/presentacion-transversales/interfacesComunes';

import IDocumentoFiltro from 'Infotrack@Modelos/negocioRefactor/entidades/consulta/documento/IDocumentoFiltro';
import IDocumento from 'Infotrack@Modelos/negocioRefactor/entidades/repositorio/IDocumento';
import IDocumentoDetalle from 'Infotrack@Modelos/negocioRefactor/entidades/repositorio/IDocumentoDetalle';
import ModeloEntradaDevolucion from 'Infotrack@Modelos/negocioRefactor/modelos/EntradaDevolucion/ModeloEntradaDevolucion';
import IDocumentoBaseConsulta from 'Infotrack@Modelos/smartStock/documentos/entidades/documentoBaseConsulta';
import { IDocumentoFirma } from 'Infotrack@Modelos/smartStock/documentos/entidades/documentoFirma';

class EntradaDevolucionCM {
    private modeloEntradaDevolucion: ModeloEntradaDevolucion;

    constructor() {
        this.modeloEntradaDevolucion = new ModeloEntradaDevolucion();
    }

    public async editarDetalle(detalle: IDocumentoDetalle) {
        if (!this.validarDetalle(detalle)) return false;
        const respuesta = await this.modeloEntradaDevolucion.editarDetalle(detalle);
        return respuesta.data.Resultado;
    }

    public async eliminarDetalle(detalle: IDocumentoDetalle) {
        const respuesta = await this.modeloEntradaDevolucion.eliminarDetalle(detalle);
        return respuesta.data.Resultado;
    }

    public async guardarDetalle(detalles: IDocumentoDetalle[]) {
        if (detalles.some((detalle) => !this.validarDetalle(detalle))) return false;
        const respuesta = await this.modeloEntradaDevolucion.guardarDetalle(detalles);
        return respuesta.data.Resultado;
    }

    public async guardarEncabezado(documento: IDocumento) {
        if (!this.validarDocumento(documento)) return { Entidades: [], Resultado: false };
        const respuesta = await this.modeloEntradaDevolucion.guardarEncabezado(documento);
        return respuesta.data;
    }

    public async editarEncabezado(documento: IDocumento) {
        if (!this.validarDocumento(documento)) return { Entidades: [], Resultado: false };
        const respuesta = await this.modeloEntradaDevolucion.editarEncabezado(documento);
        return respuesta.data;
    }

    public async anularDocumento(documentoId: string) {
        const respuesta = await this.modeloEntradaDevolucion.anularDocumento(documentoId);
        return respuesta.data.Resultado;
    }

    public consultarListaDocumentos = async (paginador: IPaginador, filtro: IDocumentoFiltro) => {
        const respuesta = await this.modeloEntradaDevolucion.consultarListaDocumentos({
            Filtro: filtro,
            Paginador: paginador,
        });
        return respuesta.data;
    };

    public async consultarDetallesDocumento(filtro: Partial<IDocumentoDetalle>) {
        const respuesta = await this.modeloEntradaDevolucion.consultarDetallesDocumento(filtro);
        return respuesta.data.Entidades;
    }

    public async consultarEncabezadoDocumento(filtro: Partial<IDocumento>) {
        const respuesta = await this.modeloEntradaDevolucion.consultarEncabezadoDocumento(filtro);
        return respuesta.data.Entidades[0];
    }

    public async consultarEtapas(documentoId: string) {
        const respuesta = await this.modeloEntradaDevolucion.consultarEtapas(documentoId);
        return respuesta.data.Entidades;
    }

    public async cambiarEtapa(documento: IDocumento, idUsuario:string) {
        const respuesta = await this.modeloEntradaDevolucion.cambiarEtapa(documento,idUsuario);
        return respuesta.data.Resultado;
    }

    public async consultarDocumentoBase(documentoBase: IDocumentoBaseConsulta) {
        const respuesta = await this.modeloEntradaDevolucion.consultarDocumentoBase(documentoBase);
        return respuesta.data.Entidades;
    }

    public async consultarDocumentoBaseFiltro(documentoBase: Partial<IDocumentoBaseConsulta>) {
        const respuesta = await this.modeloEntradaDevolucion.consultarDocumentoBaseFiltro(documentoBase);
        return respuesta.data.Entidades;
    }

    public async generarArchivoPDF(documentoId: string, idAplicacion: string) {
        const respuesta = await this.modeloEntradaDevolucion.consultarPdfDocumento(documentoId, idAplicacion);
        return respuesta.data.Entidades[0];
    }

    public async consultarDocumentoBaseLamda(documentoBase: IDocumentoBaseConsulta) {
        const respuesta = await this.modeloEntradaDevolucion.consultarDocumentoBaseLamda(documentoBase);
        return respuesta.data.Entidades;
    }

    public async guardarDocumentoFirma(documentoFirma: IDocumentoFirma) {
        const respuesta = await this.modeloEntradaDevolucion.guardarDocumentoFirma(documentoFirma);
        return respuesta.data.Entidades[0] ;
    }

    private validarDocumento(documento: IDocumento) {
        if (!documento.TipoDocumentoId) {
            notificacionGlobal('EntradaDevolucion.ValidacionNoTipoDocumentoId', 3000, 'warning', true);
            return false;
        }
        if (!documento.BodegaDestino) {
            notificacionGlobal('EntradaDevolucion.ValidacionNoBodegaDestino', 3000, 'warning', true);
            return false;
        }
        if (!documento.ClienteId) {
            notificacionGlobal('EntradaDevolucion.ValidacionNoClienteId', 3000, 'warning', true);
            return false;
        }
        return true;
    }

    private validarDetalle(detalle: IDocumentoDetalle) {
        if (!detalle.DivisionDestino) {
            notificacionGlobal('ModalRecepcion.ValidacionNoDivisionDestino', 3000, 'warning', true);
            return false;
        }
        return true;
    }
}

export default EntradaDevolucionCM;
